module.exports = __webpack_public_path__ + "img/sf.5b3300ce.png";